import { create } from 'zustand';
import api from '../lib/api';

export const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount:   0,
  total:         0,
  isLoading:     false,

  /** Fetch notifications from the server. */
  fetchNotifications: async ({ limit = 20, offset = 0, unreadOnly = false } = {}) => {
    set({ isLoading: true });
    try {
      const params = { limit: String(limit), offset: String(offset) };
      if (unreadOnly) params.unread_only = 'true';

      const data = await api.get('/notifications', params);
      set({
        notifications: data.notifications || [],
        total:         data.total || 0,
        isLoading:     false,
      });
    } catch {
      set({ isLoading: false });
    }
  },

  /** Fetch the unread count badge. Skips if no auth token. */
  fetchUnreadCount: async () => {
    if (!localStorage.getItem('token')) return;
    try {
      const data = await api.get('/notifications/unread-count');
      set({ unreadCount: data.data?.count || 0 });
    } catch {
      // fail silently
    }
  },

  /** Mark a single notification as read. */
  markRead: async (id) => {
    try {
      await api.put(`/notifications/${id}/read`);
      set((state) => ({
        notifications: state.notifications.map((n) =>
          n.id === id ? { ...n, is_read: true } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      }));
    } catch {
      // fail silently
    }
  },

  /** Mark all notifications as read. */
  markAllRead: async () => {
    try {
      await api.put('/notifications/read-all');
      set((state) => ({
        notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
        unreadCount:   0,
      }));
    } catch {
      // fail silently
    }
  },
}));
